<summary-summary-grid-item></summary-summary-grid-item>
<div class="dash-grid--item half module drop-shadow bottom">
  <div class="dashboard--module-header">
    <h2 class="subheading-sm">Issue history <button class="info-btn focus-element" (click)="onHistoryInfoClick()"><span class="focus--content" tabindex="-1"><span>i</span></span></button></h2>
  </div>
    <issues-history-chart class="block-chart"></issues-history-chart>
</div>
